
<section class="privacy-wrap ">
    <div class="wrap-lg">
      <div class="privacy-inner">
        <div class="nav-sec">
          <div class="back-nav" (click)="goTohome()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span class="nav-name"  >Back</span>
          </div>
        </div>
        <div class="privacy-content">
          <iframe [src]="iframeSrc" frameborder="0"></iframe>
        </div>
      </div>
    </div>
  </section>
  